import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';
import { Card } from '@youngcapital/component-library';

import { AppContext } from '../../AppContext';
import { SIGNUP_FOR } from '../helpers/constants';
import generateSiteName from '../../helpers/siteNameGenerator';

const UspCard = ({ t, signupFor }) => {
  const { siteAbbr } = useContext(AppContext);
  const siteName = generateSiteName(siteAbbr);
  const translationItems =
    t('fieldset_usp_card.list_items', { returnObjects: true }) || [];

  const list = isArray(translationItems)
    ? translationItems
    : [translationItems];

  const showUspCard = signupFor !== SIGNUP_FOR.apply;

  return (
    <>
      {showUspCard && (
        <div className='hidden-xs hidden-sm'>
          <Card>
            <h3>{t('fieldset_usp_card.title', { siteName })}</h3>
            <p>{t('fieldset_usp_card.text_body', { siteName })}</p>
            <ul className='list list--checkmarks'>
              {list.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </Card>
        </div>
      )}
    </>
  );
};

UspCard.propTypes = {
  t: PropTypes.func.isRequired,
  signupFor: PropTypes.string.isRequired
};

export default UspCard;
